/* tslint:disabled */
/* eslint-disable */
/**
 * Guardrails
 * The service allows to get create guardrails, update, delete, add to folder, remove from folder them. Also it allows to list, create, update and delete folders.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum GuardrailTypeEnum {
  Autocomplete = 'AUTOCOMPLETE',
  Function = 'FUNCTION'
}

export function GuardrailTypeEnumFromJSON(json: any): GuardrailTypeEnum {
  return json as GuardrailTypeEnum
}

export function GuardrailTypeEnumToJSON(value?: GuardrailTypeEnum): any {
  return value as any
}
